(function (root, factory) {
  var api = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }

  if (root) {
    api.install(root);
  }
})(typeof window !== 'undefined' ? window : null, function () {
  // shortcut: audited current patch variants only; re-audit allocations before adding SKUs.
  var VARIANT_IDS = ["52903553401112", "52903552876824", "52903552090392", "52903551697176", "52903551009048", "52903549796632", "52903548977432", "52903548191000", "52903547699480", "52903546781976", "52903546355992", "52903545569560", "52903544848664", "52903542292760", "47171808002236"];
  var SINGLE_SELLING_PLAN_ID = 6590529724;
  var BUNDLE_SELLING_PLAN_ID = 7452754200;

  function getBundleType(item) {
    return item && item.properties && item.properties._bundle_type;
  }

  function getGroupKey(item) {
    var properties = (item && item.properties) || {};
    if (!properties._bar_id || !properties._discount_id) return null;
    return String(item.id) + '\u0000' + String(properties._bar_id || '') + '\u0000' + String(properties._discount_id || '');
  }

  function haveSameProperties(left, right) {
    var leftProperties = (left && left.properties) || {};
    var rightProperties = (right && right.properties) || {};
    var leftKeys = Object.keys(leftProperties).sort();
    var rightKeys = Object.keys(rightProperties).sort();

    if (leftKeys.length !== rightKeys.length) return false;
    return leftKeys.every(function (key, index) {
      return key === rightKeys[index] && leftProperties[key] === rightProperties[key];
    });
  }

  function getQuantity(item) {
    var quantity = Number(item && item.quantity);
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  function applySellingPlan(items) {
    if (!Array.isArray(items)) return items;

    var groups = {};

    items.forEach(function (item) {
      var bundleType = getBundleType(item);
      if (!item || VARIANT_IDS.indexOf(String(item.id)) === -1 || (bundleType !== 'buy' && bundleType !== 'get')) return;

      var groupKey = getGroupKey(item);
      if (!groupKey) return;
      var group = groups[groupKey] || (groups[groupKey] = { buy: 0, get: 0 });
      group[bundleType] += getQuantity(item);
    });

    items.forEach(function (item) {
      var bundleType = getBundleType(item);
      var isBuyOrGet = bundleType === 'buy' || bundleType === 'get';
      var hasPlan = item && item.selling_plan !== undefined && item.selling_plan !== null && item.selling_plan !== '';

      if (item && VARIANT_IDS.indexOf(String(item.id)) !== -1 && isBuyOrGet && !hasPlan) {
        var group = groups[getGroupKey(item)];

        if (group && group.buy === 2 && group.get === 1) {
          item.selling_plan = BUNDLE_SELLING_PLAN_ID;
        } else if (bundleType === 'buy' && group && group.buy === 1 && group.get === 0) {
          item.selling_plan = SINGLE_SELLING_PLAN_ID;
        }
      }
    });

    var consolidated = [];
    var paidLines = {};

    items.forEach(function (item) {
      var groupKey = getGroupKey(item);
      var group = groupKey && groups[groupKey];
      var isExactBundleBuy = VARIANT_IDS.indexOf(String(item && item.id)) !== -1 && getBundleType(item) === 'buy' && group && group.buy === 2 && group.get === 1;

      if (!isExactBundleBuy) {
        consolidated.push(item);
        return;
      }

      var candidates = paidLines[groupKey] || (paidLines[groupKey] = []);
      var existing = null;
      for (var index = 0; index < candidates.length; index += 1) {
        if (String(candidates[index].id) === String(item.id) && String(candidates[index].selling_plan || '') === String(item.selling_plan || '') && haveSameProperties(candidates[index], item)) {
          existing = candidates[index];
          break;
        }
      }

      if (existing) {
        existing.quantity = getQuantity(existing) + getQuantity(item);
      } else {
        candidates.push(item);
        consolidated.push(item);
      }
    });

    consolidated.sort(function (a, b) {
      var ga = getGroupKey(a);
      var gb = getGroupKey(b);
      if (ga && ga === gb && groups[ga] && groups[ga].buy === 2 && groups[ga].get === 1) {
        var ta = getBundleType(a);
        var tb = getBundleType(b);
        if (ta !== tb) return ta === 'buy' ? -1 : 1;
      }
      return 0;
    });

    items.splice.apply(items, [0, items.length].concat(consolidated));

    return items;
  }

  function wrapAddItemsWithSections(target) {
    var original = target.addItemsWithSections;
    if (typeof original !== 'function') return false;
    if (original.apVictorySellingPlanWrapped) return true;

    function wrapped(items) {
      applySellingPlan(items);
      return original.apply(this, arguments);
    }

    wrapped.apVictorySellingPlanWrapped = true;
    target.addItemsWithSections = wrapped;
    return true;
  }

  function install(target) {
    if (wrapAddItemsWithSections(target)) return;

    var attempts = 0;
    var timer = target.setInterval(function () {
      attempts += 1;
      if (wrapAddItemsWithSections(target) || attempts >= 400) {
        target.clearInterval(timer);
      }
    }, 25);
  }

  return {
    applySellingPlan: applySellingPlan,
    wrapAddItemsWithSections: wrapAddItemsWithSections,
    install: install
  };
});
